import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { DiscoverTabContent } from './PrayerScreen';

export default function PrayerDiscoverScreen() {
  const {
    setShowAddWall, deepLinkItemId, setDiscoverCount, refreshDots,
  } = useOutletContext();

  return (
    <DiscoverTabContent
      onAddRequest={() => setShowAddWall(true)}
      highlightItemId={deepLinkItemId}
      onSwiped={remaining => { setDiscoverCount(remaining); if (remaining === 0) refreshDots(); }}
    />
  );
}
